module.exports = __webpack_public_path__ + "static/media/pilot_immo.57624c2b.png";